import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LocalStorageProductType } from '@genoa/domain'

import * as Routes from '../../routing/constants'

export const SUNSET_CREDIT_BUILDER_KEY = 'flexapp/sunset-cb-link'

export const useHandleCreditBuilderSunset = () => {
  const navigate = useNavigate()

  // We are deprecating the credit builder onboarding flow. This will force any web user
  // that is attempting to start CB to a sunset page and also remove the default product set
  const checkShouldRedirect = () => {
    const showSunset = localStorage.getItem(SUNSET_CREDIT_BUILDER_KEY) === 'true'

    if (showSunset) {
      localStorage.removeItem(SUNSET_CREDIT_BUILDER_KEY)
      localStorage.setItem('flexapp/product', LocalStorageProductType.RENT_SPLIT)
      navigate(Routes.App.CREDIT_BUILDER_SUNSET, { replace: true })

      return true
    }

    return false
  }

  return {
    checkShouldRedirect,
  }
}
